import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import type { DictationOverlayBackground } from '@atlassian/conversation-assistant-chat-prompt-input/ui/chat-prompt-input/types';

type DictationOverlaySurface = 'mini-chat' | 'cwr-staging-area-modal';

/**
 * Returns the correct `dictationOverlayBackground` value for entrypoints
 * whose prompt box sits on a non-default surface. Gated behind the
 * `ai_speech_to_text_minor_bug_fixes` experiment.
 */
export const getDictationOverlayBackground = (
	surface: DictationOverlaySurface,
): DictationOverlayBackground | undefined => {
	if (!FeatureGates.getExperimentValue('ai_speech_to_text_minor_bug_fixes', 'isEnabled', false)) {
		return undefined;
	}

	if (surface === 'mini-chat') {
		return 'surface-raised';
	}

	if (surface === 'cwr-staging-area-modal') {
		if (FeatureGates.getExperimentValue('cwr-modal-ui-refresh', 'isEnabled', false)) {
			return 'surface-raised';
		}
		return 'surface-sunken';
	}
};
